// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"b1cfaa4c-168":"f5563b96ba9b9d3f563f","b1cfaa4c-452":"dbef032c6ad8b4d5e399","b1cfaa4c-379":"48f1f870bfceed8c31c5","b1cfaa4c-83":"667a06766d370e210958"}[chunkId] + ".js";
};